export const CARD_HEIGHT = 220;
export const CARD_WIDTH = 160;
export const DRAWER_WIDTH = 240;
export const CARD_SECTIONS = 19;
export const XML_URL = 'https://mobile.tyrantonline.com/assets/';
export const XML_URL_DEV = 'https://mobile-dev.tyrantonline.com/assets/';
